import type { MetricDefinition } from "@/grid/core/types";
import { cn } from "@/lib/cn";

interface MetricNavProps {
  metrics: MetricDefinition[];
  activeId: string;
  onChange: (metricId: string) => void;
  className?: string;
}

export function MetricNav({ metrics, activeId, onChange, className }: MetricNavProps) {
  return (
    <nav className={cn("space-y-1", className)} aria-label="Metrics">
      {metrics.map((metric, index) => {
        const active = metric.id === activeId;
        return (
          <button
            key={metric.id}
            type="button"
            onClick={() => onChange(metric.id)}
            className={cn(
              "flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm transition-colors",
              active
                ? "bg-white font-medium text-[#475569] shadow-sm ring-1 ring-[#E8ECF0]"
                : "text-[#94A3B8] hover:bg-white/70 hover:text-[#64748B]",
            )}
          >
            <span className="w-5 text-xs tabular-nums opacity-50">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span>{metric.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
